import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import FollowFavourites from '../../Models/FollowFavourites';
import Pagination from "react-js-pagination";
import StarRatings from 'react-star-ratings';
import StarRatingComponent from 'react-star-rating-component';
import "bootstrap/scss/bootstrap.scss";
var striptags = require('striptags');
class AffiliatorFavorites extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('0'))
            this.props.history.push('/login/affiliator');
        };
        this.state = {
            _id: false,
            user: '',
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: 5,
            total: [],
            favorites: []
        }
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        this.state.user = logged_user.id;
    };
    componentDidMount() {
        window.scrollTo(0, 0)
        FollowFavourites.getFavourites(this.state.user, 1).then(res => {
            console.log(res.data)
            if ((res.data.payload !== null) || (res.data.payload !== '')) {
                this.setState({
                    favorites: res.data.payload,
                    total: res.data.total, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage
                })
            }
        })
    }
    handlePageChange(pageNumber) {
        // console.log(pageNumber)
        FollowFavourites.getFavourites(this.state.user, pageNumber).then(res => {
            if (res.data.payload != null) {
                this.setState({ favorites: res.data.payload, total: res.data.total, activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage })
            }
        })
    }
    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                striptags(details)
            )
        } else {
            return (
                striptags(details.substr(0, 150))
            )
        }
    }
    pagination() {
        if (this.state.total >= 5) {
            return (
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-6 ml-5">
                        <Pagination
                            hideNavigation
                            activePage={this.state.activePage}
                            itemsCountPerPage={this.state.itemsCountPerPage}
                            totalItemsCount={this.state.total}
                            pageRangeDisplayed={this.state.pageRangeDisplayed}
                            onChange={this.handlePageChange.bind(this)}
                        />
                    </div>
                    <div className="col-md-2"></div>
                </div>
            )
        }
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className="input_name big_font " style={{ width: '100%', fontSize: '20px', textAlign: 'left' }}>
                                    {this.props.t('1')}
                                </div>
                                <div style={{ minHeight: "550px" }}>
                                    <div className="col-md-12 custom_padding_dash pt-0">
                                        <div className="row">
                                            {this.state.favorites.map(group =>
                                                <div className="" key={group.id} style={{ height: '', width: '100%' }}>
                                                    <div className="" style={{ border: "1px solid #f4f2f0", padding: "20px" }}>
                                                        <div className="row" >
                                                            <div className="col-md-9 remember_text" style={{ paddingBottom: '10px' }}>
                                                                <div className="row pb-2">
                                                                    <div className="col-8">
                                                                        <Link to={{
                                                                            pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                            state: { id: group.seller_id }
                                                                        }} >
                                                                            {group.first_name}
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-4" style={{ textAlign: 'center' }}>
                                                                        <b>{group.price}</b> {this.props.t('3')}
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <Link to={{
                                                                        pathname: `/categories-details/${group.id}`,
                                                                        state: { id: group.id }

                                                                    }} style={{ textDecoration: 'none' }} className="category-right">
                                                                        <span style={{ fontSize: "14" }}><b>{group.title}</b></span><br />
                                                                    </Link>
                                                                </div>
                                                                <div>
                                                                    <span className="diff_font" >{group.short_desc}</span>
                                                                </div>
                                                                <div className="product_description" style={{ fontSize: "12" }}>
                                                                    {this.details(group.long_desc)}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div style={{}}>
                                                                    <img style={{ width: "100%", height: "120px", objectFit: 'cover' }} src={group.proimg} alt="" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />
                                                </div>
                                            )}
                                        </div>
                                        asdasd1
                                    </div>
                                    asdasd2
                                </div>
                                asdasd3
                                {this.pagination()}
                            </div>
                            asdasdasd4
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: '100%' }}>
                                            {this.props.t('1')}
                                    </div>
                                        <div style={{ minHeight: "550px" }}>
                                            <div className="custom_padding_dash pt-0">
                                                <div className="row">
                                                    {this.state.favorites.map(group =>
                                                        <div className="">
                                                            <div className="" key={group.id} style={{ height: '', border: "1px solid #f4f2f0", padding: "20px", width: '100%' }}>
                                                                <div className="row">
                                                                    <div className="col-md-9 remember_text card" style={{ border: '0px solid' }}>
                                                                        <Link to={{
                                                                            pathname: `/categories-details/${group.id}`,
                                                                            state: { id: group.id }
                                                                        }} style={{ textDecoration: 'none', color: "#999" }} className="card-title">
                                                                            <span><b>{group.title}</b></span><br />
                                                                        </Link>
                                                                        <span className="diff_font">{group.short_desc}</span>
                                                                        <div className="design_text">
                                                                        </div>
                                                                        <div to={{
                                                                            pathname: `/categories-details/${group.id}`,
                                                                            state: { id: group.id }
                                                                        }} className="product_description " style={{ textDecoration: 'none', color: "#aaa", fontSize: '12' }}>
                                                                            {this.details(group.long_desc)}
                                                                        </div>
                                                                        <div className="mt-1 col-md-12 stars ">
                                                                            <div className="row">
                                                                                <Link to={{
                                                                                    pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                                    state: { id: group.seller_id }
                                                                                }} >
                                                                                    {group.first_name}
                                                                                </Link>
                                                                                &nbsp;&nbsp;
                                                                        <div className="">
                                                                                    {/* <StarRatingComponent
                                                                                name="rate1"
                                                                                starCount={5}
                                                                                value={group.stars}
                                                                            /> */}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <img src={group.proimg} alt="" style={{ width: "100%", height: "100px", objectFit: 'cover' }} />
                                                                        <br />
                                                                        <div className="mt-2 pl-3 ml-4">
                                                                            <b>{parseInt(group.price)}</b> {this.props.t('3')}
                                                                </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <br />
                                                        </div>
                                                    )}
                                                    {this.pagination()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { AffiliatorFavorites }


 AffiliatorFavorites = withTranslation('src_Components_Affiliator_AffiliatorFavorites')(AffiliatorFavorites);
